import { createFileRoute, lazyRouteComponent, redirect } from "@tanstack/react-router"
import { z } from "zod/v4"

const searchSchema = z.object({
  email: z.string().optional(),
  redirect: z.string().optional(),
})

export const Route = createFileRoute("/_auth/magic-link-sent")({
  validateSearch: searchSchema,
  staticData: { title: "Magic Link Sent" },
  beforeLoad: ({ context, search }) => {
    if (context.userInfo.state === "LoggedIn") {
      throw redirect({ to: search.redirect ?? "/" })
    }
  },
  component: lazyRouteComponent(
    () => import("#pages/login/magic-link-sent.tsx"),
    "MagicLinkSent",
  ),
})
